module.exports = __webpack_public_path__ + "img/character.2ac04d68.png";